var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar6({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 163,
    viewBox: "0 0 164 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.044 65.1907L134.679 20.3587L138.92 24.6119L142.269 28.3912L98.9822 74.2034L97.4178 75.8591L99.6954 75.8901L163 76.754V82.2477V86.7596L99.6799 88.6056L97.4681 88.6701L98.978 90.2876L141.172 135.487L136.529 139.297L136.516 139.308L136.504 139.319L133.23 142.192L90.04 99.3007L88.4041 97.6761L88.3358 99.9806L86.4959 162H81.0061H75.6647V100.01V97.7136L73.9834 99.2782L27.3594 142.668L23.5688 138.866L20.2936 135.581L65.0025 90.3079L66.6174 88.6726L64.3201 88.6056L1 86.7596V83.2447V77.2449L64.3124 75.89L66.6008 75.841L65.01 74.1952L20.3274 27.968L24.0231 24.673L27.8084 21.2981L73.9755 65.2098L75.6647 66.8164V64.4852V1H81.0061H86.9847L88.3356 64.5064L88.3855 66.8565L90.044 65.1907Z",
    stroke: "#E6C8BC",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar6);
export default __webpack_public_path__ + "static/media/Star 6.5281906c19fafed558b40545c7cdfa29.svg";
export { ForwardRef as ReactComponent };